// eslint-disable-next-line max-lines-per-function
define( [ 'utility', 'blocks/a-textbox-format', 'dayjs', 'vendor/day/plugin/custom-parse-format', 'vendor/pikaday' ], function run( utility, textboxFormat, dayjs, customParseFormat, Pikaday ) {
	'use strict';

	var aDateFn = {
		// Default settings
		defaults : {
			firstDay : 1,
			format : FRAMEWORK.locale.settings.aDate.format,
			nativeFormat : 'YYYY-MM-DD',
			mainCalendar : 'left',
			defaultDate	: new Date(),
			maxDate : new Date(),
			minDate : new Date( 1900, 0, 1 ),
			numberOfMonths : 1,
			position : 'bottom right',
			reposition : false,
			theme : 'm-datepicker',
			disableWeekends : false,
			i18n : {
				previousMonth : FRAMEWORK.locale.settings.aDate.previousMonth,
				nextMonth : FRAMEWORK.locale.settings.aDate.nextMonth,
				months : FRAMEWORK.locale.settings.aDate.months,
				weekdays : FRAMEWORK.locale.settings.aDate.weekdays,
				weekdaysShort : FRAMEWORK.locale.settings.aDate.weekdaysShort,
			},
		},
		init : function( elm, settings ) {
			var minDate,
				maxDate;

			if ( !elm.classList.contains( 'js-a-date' ) ) {
				elm.classList.add( 'js-a-date' );

				dayjs.extend( customParseFormat ); // Extend custom parse formats for locales

				// Set settings from defaults and any specified options
				elm.aDate = { settings : utility.extend({}, aDateFn.defaults, utility.getData( elm ) ) };

				// Store the current breakpoint and if the date field is supported natively
				elm.aDate.settings.windowWidth = 0;
				elm.aDate.settings.currentBreakpoint = utility.getBreakpoint();

				// Get the min and max values for the date input and then use them as the min and max date settings for the datepicker
				minDate = elm.aDate.settings.min;
				maxDate = elm.aDate.settings.max;

				if ( typeof minDate !== 'undefined' && minDate !== null ) {
					minDate = minDate.split( '-' );
					elm.aDate.settings.minDate = new Date( minDate[ 0 ], minDate[ 1 ] - 1, minDate[ 2 ] );
				}

				if ( typeof maxDate !== 'undefined' && maxDate !== null ) {
					maxDate = maxDate.split( '-' );
					elm.aDate.settings.maxDate = new Date( maxDate[ 0 ], maxDate[ 1 ] - 1, maxDate[ 2 ] );
				}

				elm.aDate.settings.yearRange = [ elm.aDate.settings.minDate.getFullYear(), elm.aDate.settings.maxDate.getFullYear() ];

				// Setup object for functions to be hung off
				elm.aDate.setSettings = function setSettings( newSettings ) {
					aDateFn.updateSettings( elm, newSettings );
				};

				elm.aDate.loading = false;

				aDateFn.setupTextboxFormatting( elm );
				aDateFn.setupPika( elm );
			}

			if ( settings ) {
				aDateFn.updateSettings( elm, settings );
			}

			return elm.aDate;
		},

		setupTextboxFormatting : function( elm ) {
			var spacer = elm.aDate.settings.format.match( /[/|-|.|,|\s]/g ),
				splitFormat,
				formatPattern = '',
				i = 0;

			elm.setAttribute( 'maxlength', elm.aDate.settings.format.length ); // Ensure the maxlength for the field is set
			if ( spacer && spacer.length > 0 ) {
				elm.setAttribute( 'data-spacer', spacer[ 0 ] ); // Set the spacer format
				splitFormat = elm.aDate.settings.format.split( spacer[ 0 ] );

				// Loop through the split format and build up the format pattern for the textbox format module
				for ( i; i < splitFormat.length; i++ ) {
					formatPattern += splitFormat[ i ].length;
				}

				elm.setAttribute( 'data-format', formatPattern ); // Set the format pattern

				textboxFormat.initInstance( elm ); // Add autoformatting to the date input
			}
		},

		updateDatepickerDate : function( elm, keepLast ) {
			// Update the value of the hidden input with the value from the original input only if it is a valid date
			var elementValue = elm.value,
				currentValueDate = '';

			if ( keepLast ) {
				currentValueDate = elm.aDate.lastValid;
			}

			if ( elementValue === '' ) {
				// Do nothing
			} else {
				elementValue = dayjs( elementValue, elm.aDate.settings.format );
				// The the date entered is valid and within range then update the datepicker. This prevents a date from showing as selected
				if ( elementValue.isValid() && elementValue >= elm.aDate.settings.minDate && elementValue <= elm.aDate.settings.maxDate ) {
					currentValueDate = elementValue.format( elm.aDate.settings.nativeFormat );
				}
			}

			elm.aDate.hiddenInput.value = currentValueDate;
			elm.aDate.lastValid = currentValueDate; // Keep the valid value if needed

			// Set the datepicker date
			if ( elm.aDate.hiddenInput.value === '' ) {
				elm.aDate.datepicker.setDate( null );
			} else {
				elm.aDate.datepicker.setMoment( dayjs( elm.aDate.hiddenInput.value, elm.aDate.settings.nativeFormat ) );
			}
		},

		updateDateInput : function( elm ) {
			var selectedDate,
				currentValueDate = '';

			// Get the date from the hidden input and update the original input
			selectedDate = dayjs( elm.aDate.hiddenInput.value, elm.aDate.settings.nativeFormat );
			if ( selectedDate.isValid() ) {
				currentValueDate = selectedDate.format( elm.aDate.settings.format );
			}

			elm.value = currentValueDate;
			utility.trigger( elm, 'change' );
		},

		setupPika : function( elm ) {
			var pikaId = utility.makeId( 'a-date-' ),
				onResize;

			// Create a hidden input to tie the datepicker too
			elm.aDate.hiddenInput = document.createElement( 'input' );
			elm.aDate.hiddenInput.setAttribute( 'type', 'hidden' );

			elm.aDate.elmWrapper = document.createElement( 'div' );
			elm.aDate.elmWrapper.classList.add( 'a-date-wrapper' );

			utility.wrap( elm, elm.aDate.elmWrapper ); // Wrap the date input so the trigger can be attached

			elm.aDate.trigger = document.createElement( 'button' );
			elm.aDate.trigger.classList.add( 'a-date-wrapper__trigger' );
			elm.aDate.trigger.innerHTML = FRAMEWORK.locale.settings.aDate.triggerLabelSingle;
			utility.setAttributes( elm.aDate.trigger, {
				type : 'button',
				'aria-controls' : '#' + pikaId,
				'aria-expanded' : 'false',
				'aria-hidden' : 'true',
				tabindex : -1,
			});

			elm.aDate.pikaWrapper = document.createElement( 'div' );
			elm.aDate.pikaWrapper.classList.add( 'm-datepicker-wrapper' );
			elm.aDate.pikaWrapper.setAttribute( 'id', pikaId );
			elm.aDate.pikaWrapper.setAttribute( 'aria-hidden', 'true' );
			elm.aDate.pikaWrapper.style.display = 'none';

			elm.aDate.pikaWrapperInner = document.createElement( 'div' );
			elm.aDate.pikaWrapperInner.classList.add( 'm-datepicker-wrapper__inner' );

			elm.aDate.pikaWrapper.append( elm.aDate.pikaWrapperInner ); // Place inner inside the wrapper

			// Add arrow to the datepicker
			elm.aDate.arrow = document.createElement( 'span' );
			elm.aDate.arrow.classList.add( 'pika-arrow' );
			elm.aDate.pikaWrapper.append( elm.aDate.arrow );

			elm.aDate.elmWrapper.append( elm.aDate.trigger );
			elm.aDate.elmWrapper.append( elm.aDate.hiddenInput );
			document.body.append( elm.aDate.pikaWrapper ); // Place the datepicker at the bottom of the document

			aDateFn.createPika( elm );

			utility.slideToggle( elm.aDate.pikaWrapper, 0, { variant : 'up' });
			aDateFn.setupControlButtons( elm );

			onResize = utility.debounce( function listener() {
				var newWindowWidth = document.body.clientWidth;
				if ( newWindowWidth !== elm.aDate.settings.windowWidth && elm.aDate.pikaWrapper.style.display !== 'none' ) {
					elm.aDate.settings.windowWidth = newWindowWidth;
					aDateFn.resize( elm );
				}
			}, 10 );

			window.addEventListener( 'resize', onResize );
		},

		createPika : function( elm ) {
			var pikaTitle;
			// Reset the default date and then make sure its within range
			elm.aDate.settings.defaultDate = new Date();

			if ( elm.aDate.settings.defaultDate > elm.aDate.settings.maxDate ) {
				elm.aDate.settings.defaultDate = elm.aDate.settings.maxDate;
			}
			if ( elm.aDate.settings.defaultDate < elm.aDate.settings.minDate ) {
				elm.aDate.settings.defaultDate = elm.aDate.settings.minDate;
			}

			elm.aDate.datepicker = new Pikaday({
				field : elm.aDate.hiddenInput,
				firstDay : elm.aDate.settings.firstDay,
				format : elm.aDate.settings.nativeFormat,
				mainCalendar : elm.aDate.settings.mainCalendar,
				defaultDate : elm.aDate.settings.defaultDate,
				maxDate : elm.aDate.settings.maxDate,
				minDate : elm.aDate.settings.minDate,
				yearRange : elm.aDate.settings.yearRange,
				numberOfMonths : elm.aDate.settings.numberOfMonths,
				position : elm.aDate.settings.position,
				reposition : elm.aDate.settings.reposition,
				theme : elm.aDate.settings.theme,
				i18n : elm.aDate.settings.i18n,
				disableWeekends : elm.aDate.settings.disableweekends,
				ariaLabel : FRAMEWORK.locale.settings.aDate.interactionInstruction,
				showDaysInNextAndPreviousMonths : false,
				bound : false,
				container : elm.aDate.pikaWrapperInner,
				keyboardInput : false,
				onDraw : function() {
					aDateFn.onPikaDraw( elm );
				},
				onSelect : function() {
					aDateFn.updateDateInput( elm );
					aDateFn.closePika( elm, true );
				},
				disableDayFn : function( dates ) {
					if ( elm.aDate.settings.disabledays === undefined ) {
						return false;
					}
					let thisdate = dayjs( dates ).format( 'YYYY-MM-DD' );
					return elm.aDate.settings.disabledays.includes( thisdate );
				},
			});
			elm.aDate.datepicker.hide();

			pikaTitle = elm.aDate.datepicker.el.querySelector( '.pika-title' );
			if ( pikaTitle ) {
				pikaTitle = elm.aDate.datepicker.el.querySelector( '.pika-title' );
				pikaTitle.removeAttribute( 'role' );
				pikaTitle.removeAttribute( 'aria-live' ); // Remove heading role as causes issues with screen readers
				pikaTitle.removeAttribute( 'id' );
				elm.aDate.datepicker.el.querySelector( '.pika-table' ).removeAttribute( 'aria-labelledby' );
			}
		},

		onPikaDraw : function( elm ) {
			var enabledButtons,
				pikaId,
				pikaTitle;

			if ( elm.aDate.datepicker ) {
				pikaId = utility.makeId( 'date-input-title-' );
				pikaTitle = elm.aDate.datepicker.el.querySelector( '.pika-title' );
				pikaTitle.prepend( utility.htmlStringToElement( '<span class="u-hidden--visually" id="' + pikaId + '" role="heading" aria-live="assertive">' +
					FRAMEWORK.locale.settings.aDate.triggerLabelSingle + ' - ' +
					elm.aDate.settings.i18n.months[ elm.aDate.datepicker.el.querySelector( '.pika-select-month' ).value ] + ' ' +
					elm.aDate.datepicker.el.querySelector( '.pika-select-year' ).value + '</span>' ) ); // Place heading for pika inside the wrapper
				pikaTitle.removeAttribute( 'role' );
				pikaTitle.removeAttribute( 'aria-live' ); // Remove heading role as causes issues with screen readers
				pikaTitle.removeAttribute( 'id' );
				elm.aDate.datepicker.el.querySelector( '.pika-table' ).setAttribute( 'aria-labelledby', pikaId );

				// Find all the non-disabled buttons and if the user hits space or enter then trigger the click event on them
				enabledButtons = elm.aDate.datepicker.el.querySelectorAll( 'td:not(.is-disabled) button, .pika-next, .pika-prev' );
				enabledButtons.forEach( function loop( element ) {
					element.addEventListener( 'mousedown', function listener() {
						var selectedDate;
						// Delay setting the focus just a tiny bit to miss the redraw safely
						setTimeout( function timeoutFn() {
							selectedDate = dayjs( elm.aDate.hiddenInput.value, elm.aDate.settings.nativeFormat );
							if ( selectedDate.isValid() ) {
								selectedDate = selectedDate.toDate();
							}
						}, 10 );
					});
				});
			}
		},

		closePika : function( elm, focus ) {
			if ( elm.aDate.loading ) {
				// Do nothing
			} else {
				elm.aDate.loading = true;
				if ( elm.aDate.pikaWrapper.style.display === 'none' ) {
					elm.aDate.settings.windowWidth = document.body.clientWidth;
					aDateFn.resize( elm );

					// Update the hidden input then the datepicker
					aDateFn.updateDatepickerDate( elm );

					// Show the datepicker before opening the outer
					elm.aDate.datepicker.show();
				}
				setTimeout( function timeoutFn() {
					utility.slideToggle( elm.aDate.pikaWrapper, FRAMEWORK.timings.current.t350ms, {
						callback : function() {
							if ( elm.aDate.pikaWrapper.style.display === 'none' ) {
								elm.aDate.trigger.setAttribute( 'aria-expanded', 'false' );
								// Hide the datepicker once the area is closed
								elm.aDate.datepicker.hide();

								if ( focus ) {
									elm.focus();
								}
							} else {
								elm.aDate.trigger.setAttribute( 'aria-expanded', 'true' );
							}
							elm.aDate.loading = false;
						},
					});
				}, 10 );
			}
		},

		setupControlButtons : function( elm ) {
			elm.aDate.trigger.addEventListener( 'click', function listener( e ) {
				e.preventDefault();
				aDateFn.closePika( elm );
			});

			document.body.addEventListener( 'mousedown', function listener( e ) {
				var target = e.target,
					isDisplaying = elm.aDate.pikaWrapper.style.display === 'block',
					classes = target.getAttribute( 'class' ),
					pikaClass = false;

				// Match any of the pika elements as for some reason they arent found when using node.contains( element )
				if ( classes && classes.match( /pika/g ) ) {
					pikaClass = true;
				}

				if ( isDisplaying && !pikaClass && target !== elm.aDate.pikaWrapper && !elm.aDate.pikaWrapper.contains( target ) ) {
					aDateFn.closePika( elm );
				}
			});
		},

		resize : function( elm ) {
			aDateFn.repositionPicker( elm );
			elm.aDate.settings.currentBreakpoint = utility.getBreakpoint();
		},

		repositionPicker : function( elm ) {
			var elWidth = elm.aDate.elmWrapper.offsetWidth,
				leftOffset = utility.offset( elm.aDate.elmWrapper ).left,
				documentWidth = document.body.clientWidth,
				pickerWidth = elm.aDate.pikaWrapper.offsetWidth,
				adjustment = 0,
				leftPos = 0,
				topPos = 0;

			if ( elm.aDate.pikaWrapper.style.display === 'none' ) {
				elm.aDate.pikaWrapper.style.display = 'block';
				pickerWidth = elm.aDate.pikaWrapper.offsetWidth;
				elm.aDate.pikaWrapper.style.display = 'none';
			}

			if ( elWidth > pickerWidth ) {
				leftPos = leftOffset + elWidth - pickerWidth;

				// If the picker does not fit on the page shift right
				if ( leftPos < 0 ) {
					adjustment = pickerWidth - ( leftOffset + elWidth );
				}
			} else {
				leftPos = leftOffset;

				// If the picker does not fit on the page shift left
				if ( leftPos + pickerWidth > documentWidth ) {
					adjustment = documentWidth - ( leftPos + pickerWidth );
				}
			}

			leftPos += adjustment;
			topPos = utility.offset( elm.aDate.elmWrapper ).top + elm.aDate.elmWrapper.offsetHeight;

			if ( elm.aDate.arrow ) {
				elm.aDate.arrow.style.left = leftOffset + elWidth - leftPos - 20 + 'px';
			}

			if ( leftPos !== 0 ) {
				leftPos += 'px';
			}
			if ( topPos !== 0 ) {
				topPos += 'px';
			}

			elm.aDate.pikaWrapper.style.left = leftPos;
			elm.aDate.pikaWrapper.style.top = topPos;
		},

		formatDateVal : function( value ) {
			var newValue = value;
			if ( newValue < 10 ) {
				newValue = '0' + newValue;
			}

			return newValue;
		},

		updateSettings : function( elm, newSettings ) {
			var newMinDate,
				newMaxDate,
				startYear = elm.aDate.settings.minDate.getFullYear(),
				endYear = elm.aDate.settings.maxDate.getFullYear(),
				minDate,
				maxDate,
				newDate;

			if ( typeof newSettings.minDate === 'string' ) {
				newMinDate = newSettings.minDate.split( '-' );

				newMinDate = new Date( newMinDate[ 0 ], newMinDate[ 1 ] - 1, newMinDate[ 2 ] );

				if ( newMinDate.getTime() !== elm.aDate.settings.minDate.getTime() ) {
					elm.aDate.settings.minDate = newMinDate;

					startYear = elm.aDate.settings.minDate.getFullYear();

					minDate = startYear + '-' + aDateFn.formatDateVal( elm.aDate.settings.minDate.getMonth() + 1 ) + '-' + aDateFn.formatDateVal( elm.aDate.settings.minDate.getDate() );
					elm.setAttribute( 'data-min', minDate );
				}
			}
			if ( typeof newSettings.maxDate === 'string' ) {
				newMaxDate = newSettings.maxDate.split( '-' );

				newMaxDate = new Date( newMaxDate[ 0 ], newMaxDate[ 1 ] - 1, newMaxDate[ 2 ] );

				if ( newMaxDate.getTime() !== elm.aDate.settings.maxDate.getTime() ) {
					elm.aDate.settings.maxDate = newMaxDate;

					endYear = elm.aDate.settings.maxDate.getFullYear();

					maxDate = endYear + '-' + aDateFn.formatDateVal( elm.aDate.settings.maxDate.getMonth() + 1 ) + '-' + aDateFn.formatDateVal( elm.aDate.settings.maxDate.getDate() );
					elm.setAttribute( 'data-max', maxDate );
				}
			}

			elm.aDate.settings.yearRange = [ startYear, endYear ];

			if ( typeof newSettings.value === 'string' ) {
				newDate = newSettings.value.split( '-' );

				newDate = new Date( newDate[ 0 ], newDate[ 1 ] - 1, newDate[ 2 ] );
				elm.value = dayjs( newDate ).format( elm.aDate.settings.format );
				utility.trigger( elm, 'change' );
			}

			// Rebuild the pika to pick up the latest settings (unless locale, which has to be dealt with in the require block)
			elm.aDate.datepicker.destroy();
			aDateFn.createPika( elm );
		},
	};

	return {
		initInstance : function( elm, settings ) {
			return aDateFn.init( elm, settings );
		},
	};
});
